function Preloader() {
    return <div className="progress">
        <h2 style={{textAlign: "center", color: "white"}}>Загрузка...</h2>
    </div>
}

export default Preloader;